import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
export default {
  components: {HeadDetailsGama},
  name: 'Salesinformation',
  props: ['selectedComissao']
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/commissioncheck/components/salesinformation/salesinformation.js